import {useFormContext} from "react-hook-form";

import Button from "@/components/button/Button.tsx";
import {UnsavedIndicator} from "@/components/unsavedIndicator/UnsavedIndicator.tsx";

interface FormActionsBarProps {
  formId: string;
  submitText?: string;
  onCancel: () => void;
  disableSubmit?: boolean;
  showUnsavedIndicator?: boolean;
}

export const FormActionsBar = ({
  formId,
  submitText = "Save",
  onCancel,
  disableSubmit,
  showUnsavedIndicator = true,
}: FormActionsBarProps) => {
  const {formState} = useFormContext();
  const shouldDisableSubmit = disableSubmit ?? !formState.isDirty;
  const shouldShowIndicator = showUnsavedIndicator && formState.isDirty;

  return (
    <div className="d-flex flex-column flex-md-row gap-3 align-items-center flex-wrap justify-content-md-end justify-content-center">
      {shouldShowIndicator && <UnsavedIndicator />}
      <div className="d-flex align-items-center justify-content-md-between justify-content-center gap-2">
        <Button variant="secondary" size="large" onClick={onCancel}>
          Cancel
        </Button>
        <Button className="text-nowrap" size="large" type="submit" form={formId} disabled={shouldDisableSubmit}>
          {submitText}
        </Button>
      </div>
    </div>
  );
};
